export default {
    'modify-amount-received': 'Modify Amount Received',
}